export const PaymentType = {
  list: function () {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#payment-type-list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              if (data.href) {
                return jQuery(data.modal ? "#payment-type-modal-link-template" : "#payment-type-link-template")
                  .html()
                  .replace(/__label__/g, data.label)
                  .replace(/__href__/g, data.href)
                  .replace(/__title__/g, data.title);
              } else {
                return data.label;
              }
            } else {
              return data.label;
            }
          },
          targets: [0, 1],
        },
        {
          targets: [-1],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        ActionJS.PaymentType.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var table = jQuery("#payment-type-list");
    table.DataTable(options);
  },

  priv: {
    bindEvent: function () {
      jQuery(".payment-type-delete-link")
        .off("click")
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data("confirm")) {
            c = confirm(jQuery(this).data("confirm"));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr("href"),
                method: "POST",
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
              })
              .done(function (d) {
                Turbo.visit(window.location.href);
              })
              .fail(function (e) {
                alert((((e.responseJSON || {}).id || [])[0] || {}).message || I18n.t("unexpected_error"));
              });
          }
          e.preventDefault();
        });
    },
  },
};
